/* 
	MX200 Sensor Controller 

	Supported sensors:
	Gas type and parameter Sensor MFG Gas Range species, PWM range, multiplier
	0 Luminox O2 25% 2, 25000, 10
	1 Luminox O2 50% 2, 50000, 10
	2 GSS CO2 1% 1, 10000, 1
	3 GSS CO2 5% 1, 5000, 10
	4 GSS CO2 20% 1, 20000, 10
	5 GSS CO2 65% 1, 65000, 10
	6 GSS CO2w 100% 1, 10000, 100
*/

import Serial from "serial";

const ERROR_CODES = {
  1: "ERROR_UNRECOGNIZED_COMMAND",
  2: "ERROR_BAD_FORMAT",
  3: "ERROR_BAD_VALUE",
  4: "ERROR_BAD_DATE_STRING",
  5: "ERROR_RTC_WRITE",
  6: "ERROR_EEPROM_READ",
  7: "ERROR_BAD_PARAMETER",
  8: "ERROR_VALUE_ALREADY_SET",
  9: "ERROR_COMMAND_FAILED",
  10: "ERROR_NOT_IMPLEMENTED",
  11: "ERROR_NOT_CONFIGURED"
}


class MX200 {
  static constructor() {
    MX200.MODE_COMMAND = 0;
    /* other modes are not implemented
    MX200.MODE_STREAMING = 1;
    MX200.MODE_POLLING = 2;
    */
  }
  constructor() {
  }
  open(path) {
    return( new Promise(function(resolve, reject) {
      var serial = new Serial();

      serial.onerror = function(event) {
        reject(event.message);
      }.bind(this);

      serial.onsuccess = function(event) {
        serial.onsuccess = function(event) {
          resolve(true);
        }.bind(this);
        serial.flush();
      }.bind(this);

      serial.open(path, {
        baudrate: 9600,
        databits: 8,
        parity: "none",
        stopbits: 1
      });

      this.__serial = serial;
    }.bind(this)) );
  }
  close() {
    return( new Promise(function(resolve, reject) {
      this.__serial.onerror = function(event) {
        reject(event.message);
      }.bind(this);
      this.__serial.onsuccess = function(event) {
        resolve(true);
      }.bind(this);
      this.__serial.close();
    }.bind(this)) );
  }
  command(cmd) {
    return( new Promise(function(resolve, reject) {
      var message = "";
      this.__serial.onmessage = function(event) {
        var uint8Array = new Uint8Array(event.data);
        var str = new TextDecoder("utf-8").decode( uint8Array );
        message += str;
        if (message.endsWith("\r\n")) {
          if (message.startsWith("E")) {
            message = message.replace("\r\n", "");
            message = message.replace(" ", "");
            message = message.replace("E", "");
            var error_code = parseInt(message);
            reject(ERROR_CODES[error_code]);
          } else {
            message = message.replace("\r\n", "");
            message = message.replace(" ", "");
            message = message.replace(cmd, "");
            resolve(message);
          }
        }
      }.bind(this)
      this.__serial.send(cmd+"\r\n");
    }.bind(this)) );
  }
  async getDeviceInformation() {
    return await this.command("Y");
  }
  async getSensorType() {
    return await this.command("G");
  }
  /* this command is not implemented
  async setCommunicationMode(mode) {
    await this.command(`K ${mode}`);
  }
  */
  async getFilteredGasConcentration() {
    var multiplier = await this.command(".");
    /* MX200 documentation: Note that 0 is used for a multiplier of 0.1 */
    if (multiplier==0) multiplier=0.1;
    var co2 = await this.command("Z");
    return multiplier * co2;
  }
  async getOnBoardRelativeHumidity() {
    var h = await this.command("H");
    return h/10;
  }
  /*  Get Temperature (O2 UV Flux sensor) */
  async getInternalTemperature() {
    var t = await this.command("T");
    t = t-1000;
    t = t/10;
    return t;
  }
  /* Get Temperature (On board RH & T sensor) */
  async getOnBoardTemperature() {
    var t = await this.command("t");
    t = t-1000;
    t = t/10;
    return t;
  }
  /*  Get internal baromteric pressure */
  async getInternalBarometricPressure() {
    var p = await this.command("b");
    p = parseInt(p);
    return p;
  }
  /* Get on-board Barometric Pressure (On board) */
  async getOnBoardBarometricPressure() {
    var p = await this.command("B");
    p = parseInt(p);
    return p;
  }
  /* 
	 Basic Calibration
	 Basic Calibration requires first that an accurate zero be set (typically with Nitrogen Gas at
	 25C +- 1C) and then that a known gas concentration be provided (also at 25C +-1C) and
	 allowed to completely stabilize.

	 The zero-calibration point is set using the U command. The span reference point is set
	 using the X command. When the X command is executed the microcontroller makes the
	 necessary calculations and stores these in the parameter storage. 
  */
  async zeroCalibrateIn0ppm() {
    return await this.command("U");
  }
  async calibrateTo(ppm) {
    var multiplier = await this.command(".");
    /* MX200 documentation: Note that 0 is used for a multiplier of 0.1 */
    if (multiplier==0) multiplier=0.1;
    ppm /= multiplier;
    ppm = Math.round(ppm);
    return await this.command(`X ${ppm}`);
  }
}

MX200.constructor();

export default MX200;